import PropTypes from 'prop-types'
import Button from '@/shared/components/UI/Button'
import CheckCircleIcon from '@/shared/icons/CheckCircleIcon'
import { useUserStore } from '@/stores/user/userStore'

const BulletItem = ({ text }) => (
  <li className="flex items-center gap-v3-xs">
    <CheckCircleIcon className="text-v3-green-dark w-5 h-5 flex-shrink-0" />
    <span className="text-v3-black-secondary text-v3-h9 font-inter-variable">{text}</span>
  </li>
)

BulletItem.propTypes = {
  text: PropTypes.string.isRequired,
}

const StepExpensive = ({
  downgradeInsights,
  onPause,
  onDowngrade,
  onLeave,
  isPauseLoading,
  isDowngradeLoading,
}) => {
  const tierPriceFromUser = useUserStore((s) => s.user?.tier_price_as_float)
  const currentPrice = downgradeInsights?.current_tier_price ?? downgradeInsights?.tier?.current_price
  const displayCurrent =
    typeof currentPrice === 'number' && !Number.isNaN(currentPrice)
      ? currentPrice
      : typeof tierPriceFromUser === 'number' && tierPriceFromUser > 0
        ? tierPriceFromUser
        : 99
  const lowerTierName = downgradeInsights?.tier?.name || 'Starter'
  const lowerTierPrice = downgradeInsights?.tier?.price ?? 29

  return (
    <div className="flex flex-col gap-v3-md w-full">
      <p className="text-v3-black-secondary text-v3-h9 font-inter-variable">
        The full plan isn&apos;t always the right fit for every month. Here&apos;s the option most
        people choose when cost is the issue.
      </p>

      <div className="rounded-v3-lg border-2 border-v3-purple-primary bg-v3-purple-bg p-v3-md flex flex-col gap-v3-sm w-full max-w-[80%] mx-auto">
        <span className="self-start text-[11px] font-semibold bg-v3-purple-primary text-white px-2 py-0.5 rounded-full">
          Recommended
        </span>

        <div className="flex flex-col">
          <h3 className="text-v3-h4 font-bold text-v3-black-max">Pause for $5/mo</h3>
          <p className="text-v3-black-secondary text-v3-h9 font-inter-variable">
            Keep every agent, conversation, and integration. Pay almost nothing until you&apos;re
            ready.
          </p>
        </div>

        <ul className="flex flex-col gap-v3-xs">
          <BulletItem text="All your agents & conversations preserved" />
          <BulletItem text="Resume in one click, no re-setup" />
          <BulletItem text={`Pay $5/mo instead of $${displayCurrent}/mo`} />
        </ul>

        <Button
          variant="primary"
          size="lg"
          label="Pause for $5/mo"
          onClick={onPause}
          disabled={isPauseLoading}
          loading={isPauseLoading}
          loadingLabel="Processing..."
        />
      </div>

      {/* <div className="rounded-v3-md border border-v3-card-border bg-white p-v3-md flex flex-col gap-v3-sm">
        <p className="text-[13px] text-v3-black-secondary font-inter-variable">
          Prefer to stay on a live plan at a lower price? You can switch to {lowerTierName} (
          <span className="font-semibold text-v3-black-max">${lowerTierPrice}/mo</span>
          ) instead.
        </p>
        <Button
          variant="secondary"
          size="md"
          label={`Downgrade to ${lowerTierName}`}
          onClick={onDowngrade}
          disabled={isDowngradeLoading}
          loading={isDowngradeLoading}
          loadingLabel="Processing..."
          className="w-full sm:w-auto self-start"
        />
      </div> */}

      <div className="flex justify-center w-full pt-v3-xs">
        <Button variant="transparent" label="I still want to cancel" onClick={onLeave} />
      </div>
    </div>
  )
}

StepExpensive.propTypes = {
  downgradeInsights: PropTypes.shape({
    tier: PropTypes.shape({
      name: PropTypes.string,
      price: PropTypes.number,
      current_price: PropTypes.number,
    }),
    current_tier_price: PropTypes.number,
  }),
  onPause: PropTypes.func.isRequired,
  onDowngrade: PropTypes.func.isRequired,
  onLeave: PropTypes.func.isRequired,
  isPauseLoading: PropTypes.bool,
  isDowngradeLoading: PropTypes.bool,
}

StepExpensive.defaultProps = {
  downgradeInsights: null,
  isPauseLoading: false,
  isDowngradeLoading: false,
}

export default StepExpensive
